export enum WidgetAction {
  EDIT = 'EDIT_ACTION',
  DELETE = 'DELETE_ACTION',
  PREVIEW = 'PREVIEW_ACTION'
}
